export enum AUTH_COOKIES {
  ACCESS_TOKEN = "ACCESS_TOKEN",
  // eslint-disable-next-line @typescript-eslint/naming-convention
  kk_customer_id = "kk_customer_id",
  LOCAL_STORAGE_REFRESH_TOKEN_NAME = "refreshToken",
}

export const ANON_USER_ID = "katkin-user-token";
